import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class FullscreenButtonComponent extends Component
{
	@service fullscreen;

	@action toggleFullscreen()
	{
		this.fullscreen.toggle();
	}
}
